import {
    type FeatureDisabledResponse,
    isFeatureDisabledResponse,
} from "@common/schemas/feature-flag-response.schema";
import { FeatureDisabledError } from "./featureDisabledError";

export function parseFeatureFlagGatedResponse<TData extends object>(
    body: TData | FeatureDisabledResponse,
): TData {
    if (isFeatureDisabledResponse(body)) {
        throw new FeatureDisabledError();
    }
    return body;
}
